import { create } from "zustand";

const useCurrentTabStore = create(set => ({
  currentTab: "energy",
  setCurrentTab: currentTab => set({ currentTab })
}));

export default useCurrentTabStore;
